<div class="border-end px-3 py-2 text-center">
    <div class="text-dark h6">
        <strong *ngIf="finalBaseAmount">{{finalBaseAmount | number : '1.0-0' | usNumber}} {{baseCurrencyCode}}</strong>
        <strong *ngIf="!finalBaseAmount">0 {{baseCurrencyCode}}</strong>
    </div>
    <div class="text-muted fw-bold">Total Gap</div>
</div>
